import React, { useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from '../../AuthContext'
import { Title, SubtitleOpen } from '../../Utils/CustomClasses'
import MyFreebirdConditionalLink from '../MyFreebirdConditionalLink'
import styled from 'styled-components'
import moment from 'moment'

const EventDatesWrapper = styled.div`
  margin: 0 0 40px 0;
`

const EventsDateTitle = styled(Title)`
  font-size: 18px !important;
`

const EventTitle = styled(SubtitleOpen)`
  font-weight: 300;
  font-size: 16px;

  b {
    font-weight: 600;
  }
`

const MemberEvents = ({
  pageText,
  accountStatus,
  subscriptionType,
  titleTrigger,
  messageTrigger,
  forbiddenLinkClicked,
}) => {
  const [results, setResults] = useState('')
  const [resultsType, setResultsType] = useState('')

  useEffect(() => {
    axios
      .get(`/api/VYGVA82re2f8e2/events?perpage=6&pageno=1&type=future`)
      .then((response) => {
        setResultsType(response.data.type)
        setResults(
          response.data.events.map((d, index) => {
            return (
              <EventDatesComponent
                key={index}
                date={moment(d.starts_at).format('DD/MM/YYYY') + ':'}
              >
                <MyFreebirdConditionalLink
                  linkUrl={'/dashboard/community2?lp=events/' + d.slug}
                  accountStatus={accountStatus}
                  subscriptionType={subscriptionType}
                  messageTrigger={messageTrigger}
                  forbiddenLinkClicked={forbiddenLinkClicked}
                >
                  <EventTitle size="18px" margin="0 0 25px 0">
                    <b>{moment(d.starts_at).format('LT')}:</b> {d.name + ' '}
                  </EventTitle>
                </MyFreebirdConditionalLink>
              </EventDatesComponent>
            )
          })
        )
        response.data.type === 'future'
          ? titleTrigger(pageText[39])
          : titleTrigger(pageText[43])
      })
      .catch((err) => {
        console.log('Error getting member events: ', err)
      })
  }, [accountStatus])

  const EventDatesComponent = ({ date, slug, children }) => {
    return (
      <EventDatesWrapper>
        <EventsDateTitle color="#0BAC5D" size="18px" margin="10px 0 10px 0">
          {date}
        </EventsDateTitle>
        {children}
      </EventDatesWrapper>
    )
  }

  if (!results) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ margin: '100px auto 100px', opacity: '0.3' }}
          role="status"
        ></div>
      </div>
    )
  }
  return results
}

export default withRouter(withAuth(MemberEvents))
